module.exports = __webpack_public_path__ + "images/category_lp/camera/new/store_images/3@2x_8e00ee350ee79f8dbd0270da4907b503.png";